import React from 'react';
import { industrializationData } from '../mock';
import { Clock, Recycle, Zap, ShieldCheck, TrendingDown, Leaf } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const iconMap = {
  clock: Clock,
  recycle: Recycle,
  zap: Zap,
  'shield-check': ShieldCheck,
  'trending-down': TrendingDown,
  leaf: Leaf
};

const Industrialization = () => {
  return (
    <section id="industrializacion" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">
            {industrializationData.title}
          </h2>
          <div className="w-24 h-1 bg-[#5E8B7E] mx-auto mb-6"></div>
          <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
            {industrializationData.description}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {industrializationData.benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <Card
                key={index}
                className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-gradient-to-br from-white to-gray-50"
              >
                <CardContent className="p-6">
                  <div className="flex items-start">
                    <div className="p-3 bg-[#5E8B7E]/10 rounded-lg mr-4">
                      <IconComponent className="text-[#5E8B7E]" size={28} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-[#0A3A48] mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-[#4A4A4A] text-sm leading-relaxed">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image and Systems */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl font-bold text-[#0A3A48] mb-6">Sistemas Constructivos</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Desarrollamos y certificamos diversos sistemas de construcción industrializada adaptados a las necesidades específicas de cada proyecto.
            </p>
            <div className="flex flex-wrap gap-3">
              {industrializationData.systems.map((system, index) => (
                <Badge
                  key={index}
                  variant="outline"
                  className="px-4 py-2 text-sm border-[#5E8B7E] text-[#0A3A48] hover:bg-[#5E8B7E] hover:text-white transition-colors cursor-pointer"
                >
                  {system}
                </Badge>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <img
              src={industrializationData.image}
              alt="Industrialización"
              className="rounded-lg shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industrialization;